import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { sectionBaca } from './style';
import { Col, Row, Tabs, Tab, Container, Card, Button } from 'react-bootstrap';
import { Book } from 'react-bootstrap-icons';
import TipeTulisan from './TipeTulisan';

const ReadingSection = ({
    listNovelnya, bukudipilihnya, partdipilihnya
  }) => {
  return (
      <div className={sectionBaca}>
          <div className="sekatAtas"/>
        <h1 className="judulnya">{listNovelnya[bukudipilihnya-1].listChapter[partdipilihnya-1].judulChapter}</h1>
        <div className="buatTulisan">
        <div className="containerTulisan" >
            {listNovelnya[bukudipilihnya-1].listChapter[partdipilihnya-1].listParagraf.map((post) =>(
                                <div>
                                <TipeTulisan tulisannya = {post.paragraf} />
                            <div className="sekatChapter"/>
                            </div>
                            )
                )}
                </div>
        </div>
        
        
    </div>
  );
};
export default ReadingSection;
